import React from 'react';
import PropTypes from 'prop-types';
import ConnectedViewerRetrieveStudyData from '../connectedComponents/ConnectedCTViewerRetrieveStudyData';

function CTViewerRouting({ match }) {
  const {
    studyInstanceUids,
    seriesInstanceUids,
    sopInstanceUids,
    diagId,
  } = match.params;

  let [studyUIDs, seriesUIDs, sopUIDs] = [null, null, null];

  if (studyInstanceUids && !seriesInstanceUids) {
    studyUIDs = studyInstanceUids.split(';');
  } else if (studyInstanceUids && seriesInstanceUids && sopInstanceUids) {
    studyUIDs = [studyInstanceUids];
    seriesUIDs = seriesInstanceUids.split(';');
    sopUIDs = sopInstanceUids.split(';');
  }
  return (
    <ConnectedViewerRetrieveStudyData
      studyInstanceUids={studyUIDs}
      seriesInstanceUids={seriesUIDs}
      sopInstanceUids={sopUIDs}
      diagId={diagId}
    />
  );
}

CTViewerRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      studyInstanceUids: PropTypes.string.isRequired,
      seriesInstanceUids: PropTypes.string,
      sopInstanceUids: PropTypes.string,
      diagId: PropTypes.string,
    }),
  }),
};

export default CTViewerRouting;
